import React from 'react';
import PropTypes from 'prop-types';

import {MapContainer, TileLayer, Marker, useMapEvent} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon issue in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MapHandler = (props) => {
  const {onLocationClick} = props;
  useMapEvent('click', (e) => {
    if (onLocationClick) {
      onLocationClick(e.latlng);
    }
  });
  return null;
};
MapHandler.propTypes = {
  onLocationClick: PropTypes.func,
};

const MapComponent = (props) => {
  const {height, width, coordinates, onLocationClick} = props;

  return (
    <MapContainer
      center={coordinates}
      zoom={15}
      style={{
        height: height,
        width: width,
      }}
    >
      <MapHandler onLocationClick={onLocationClick} />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={coordinates}/>
    </MapContainer>
  );
};

MapComponent.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  coordinates: PropTypes.array.isRequired,
  onLocationClick: PropTypes.func,
};

export default MapComponent;
